<template>
  <div class="product-banner" :style="banner.styleArr" :id ="banner.title">
    <div class="banner-info need-padding">
      <span class="tips">{{ banner.title }}</span>
      <span class="title" v-html="banner.bigDescriptionHtml"></span>
      <div class="banner-discription-group">
        <span class="description" v-html="banner.descriptionHtml"></span>
      </div>
      <div class="link-group">
<!--        如果是路由，则走路由，不是则直接跳转到外部页面-->
        <router-link v-if="banner.isRouter" :to="banner.buttonHref">
          <a class="primary-button">{{ banner.buttonName }}</a>
        </router-link>
        <a v-else class="primary-button" :href="banner.buttonHref" target="_blank">{{ banner.buttonName }}</a>
        <a class="second-link" :href="banner.buttonLink"
           target="_blank">{{ banner.linkName }}</a>
      </div>
    </div>
    <div class="banner-pic">
      <img class="banner-pic-img" :src="banner.pic" alt="banner image">
    </div>
  </div>
</template>

<script>

export default {
  name: 'LaputaImageBanner',
  props: ['banner']
}
</script>

<style scoped>
.product-banner {
  background-image: linear-gradient(180deg, #02162A 0%, #00001e 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 94px 0 0 0;
  height: fit-content;
  /*移除两个大的div连接是的间隔*/
  margin: 40px 0;
  overflow: hidden;
  /*给内部绝对定位子元素做定位参照容器，子的 bottom/top 是相对于这个盒子*/
  position: relative;
  min-height: 900px;
  width: calc(100% - 48px);
  border-radius: 28px;
}
.banner-discription-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0.8;
  margin: 24px 0 32px 0;
}
.banner-pic-img {
  max-width: 968px;
  width: 100%;
  margin: auto;
}
.banner-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.link-group {
  margin-bottom: 24px;
  display: flex;
  align-items: center;
}
.banner-info span.description {
  font-size: var(--laputa-fontsize-16);
  color: var(--laputa-card-background-white);
  text-align: center;
}
.product-banner .tips {
  color: var(--laputa-yellow);
  font-size: var(--laputa-fontsize-14);
}

.product-banner span.title {
  font-size: var(--laputa-fontsize-56);
  color: var(--laputa-card-background-white);
  font-weight: bold;
  text-align: center;
  line-height: 60px;
  margin-top: 12px;
}

:deep(span.punctuation) {
  position: absolute;
}
a.primary-button {
  padding: 8px 26px;
  background: var(--laputa-card-background-white);
  color: var(--laputa-black);
  border-radius: 26px;
  transition: ease-in-out 0.3s;
  white-space: nowrap;
  font-size: var(--laputa-fontsize-15);
}

a.primary-button:hover {
  background: var(--laputa-black);
  color: var(--laputa-card-background-white);
}
a.second-link {
  color: var(--laputa-card-background-white);
  opacity: 0.6;
  font-size: var(--laputa-fontsize-14);
  margin-left: 12px;
  transition: ease-in-out 0.3s;
}

a.second-link:hover {
  opacity: 1;
}
.banner-pic {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  height: 400px;
  width: 100%;
  bottom: 100px;
}
.inline-word {
  word-break: keep-all;
  white-space: nowrap;
}
a {
  text-decoration: none;
  user-select: none;
  -webkit-user-drag: none;
}
span {
  user-select: none;
}
sup {
  font-size: 12px;
  background: var(--laputa-green);
  color: var(--laputa-card-background-white);
  padding: 4px;
  border-radius: 4px;
  margin-left: 6px;
  white-space: nowrap;
  position: absolute;
  top: -4px;
}
sup.hot {
  background: var(--laputa-red);
}

img {
  user-select: none;
  -webkit-user-drag: none;
}

@media screen and (max-width: 375px) {
  .first-stack {
    margin-bottom: 20px;
  }

  .left-Introduce {
    margin-bottom: 40px;
  }

  a.about-button {
    margin-top: 40px;
  }



  .product-banner {
    padding-top: 40px;
  }

  .banner-pic {
    margin-top: 0px;
    height: 150px;
  }

  a.linkbutton {
    margin-left: 8px;
  }

  .footer {
    margin-top: 20px;
  }

  .title-group .title {
    font-size: 35px;
    line-height: 1.2;
  }

  span.discription-text {
    font-size: 16px;
    line-height: 1.2;
  }

  a.about-button {
    padding: 0 24px;
  }

  .nav-center {
    display: none;
  }
}
@media screen and (max-width: 768px) {
  .product-banner {
    width: 94%;
    margin: 0 0 40px 0;
  }
  .first-stack {
    margin-bottom: 20px;
  }

  .left-Introduce {
    margin-bottom: 40px;
  }

  a.about-button {
    margin-top: 40px;
  }

  body .need-padding {
    width: 80%;
  }

  .first-stack {
    flex-direction: column;
    margin-top: 120px;
  }


  .footer {
    flex-direction: column;
    margin-top: 20px;
  }

  .footer .info {
    margin-bottom: 12px;
  }

  .show-menu .nav {
    background: var(--laputa-black);
  }

  .show-menu .nav-content {
    background: var(--laputa-black);
  }

  .nav-right .nav-item {
    display: none;
  }

  .nav-right .nav-menu {
    display: flex;
    color: var(--laputa-card-background-white);
    padding: 8px 0 8px 8px;
  }

  .product-banner span.title {
    font-size: 40px;
    line-height: 46px;
  }

  .show-menu .menu-list {
    height: 100%;
    opacity: 1;
  }

  .menu-list a.nav-item {
    padding: 8px 8px;
    font-size: 16px;
    border-bottom: 1px solid #ffffff53;
    width: 90%;
    margin-left: 0;
  }

  .show-menu .menu-list a.nav-item {
    padding: 12px 8px;
  }

  .banner-pic {
    height: 200px;
    bottom: 40px;
  }

  .product-banner {
    padding-top: 60px;
    min-height: 520px;
  }

  a.linkbutton {
    margin-left: 0px;
  }

  img.hello-img {
    display: none;
  }

  .banner-pic-img {
    width: 100vw;
  }

  .nav-center {
    display: none;
  }
}
@media screen and (max-width: 1200px) {
  .special-card {
    display: none;
  }

  .banner-pic {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  img.hello-img {
    transform: translate(-60px, 55px) scale(1.5);
  }

}
</style>
